import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_INGREDIENT = `${BACKEND_BASEURL}api/ingredients/`;

const createIngredient = async (ingredientData) => {
  const response = await axios.post(
    API_INGREDIENT + "createIngredient",
    ingredientData
  );
  return response.data;
};

const getIngredients = async () => {
  const response = await axios.get(API_INGREDIENT + "getIngredients");
  return response.data;
};

const updateIngredient = async (ingredientData) => {
  const response = await axios.patch(
    API_INGREDIENT + "updateIngredient",
    ingredientData
  );
  return response.data;
};
const deleteIngredient = async (id) => {
  const response = await axios.delete(
    API_INGREDIENT + "deleteIngredient/" + id
  );
  return response.data.message;
};
const IngredientServices = {
  getIngredients,
  createIngredient,
  updateIngredient,
  deleteIngredient,
};
export default IngredientServices;
